import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import styled from 'styled-components'
import SectionTC from '../../components/section-tc/section-tc'
import { device } from '../../config/theme/breakpoints'
import FeatureItem from '../landing/components/feature-item/feature-item'
import { listFeature, listOfferItem } from '../landing/data'
import CustomSlider from '../../components/custom-slider/custom-slider'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import Slider from "react-slick";
import OfferItem from '../landing/components/offer-item/offer-item'
import TitleSection from '../../components/title-section/title-section'
import AlertTC from '../../components/alert-tc/alert-tc'
import { ExclamationCircle } from '@styled-icons/heroicons-outline'
import ButtonTC from '../../components/button-tc/button-tc'
import voucher from '../../assets/img/voucher.png'
import InputTC from '../../components/input-tc/input-tc'
import { NumberSymbol } from '@styled-icons/fluentui-system-filled'
import { ListUl } from '@styled-icons/bootstrap'
import { Lock } from '@styled-icons/octicons'
import SelectTC from '../../components/select-tc/select-tc'
import { listParecelService } from './data'
import ParcelServiceItem from './components/parecel-service-item/parcel-service-item'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 50px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`

const ContainerStatus = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`
const ContainerForm = styled.div`
  width: 100%;

  > div {
    margin-top: 50px;
  }

  > h2 {
    color: ${p => p.theme.palette.text.gray};
  }

  > h2 span{
    color: ${p => p.theme.palette.text.primary};
  }

  > p{
    font-size: 13px;
  }

  @media ${device.tablet}{
    width: 46%;
  }
`
const ContainerImageForm = styled.div`
  width: 100%;
  text-align: center;

  > img{
    max-width: 80%;
  }
  @media ${device.tablet}{
    width: 46%;
  }
`

const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div{
    width: 100%;

    @media ${device.tablet}{
      width: 50%;
    }
  }
`
const ContainerParcelsService = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin-top: 30px;
`

const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`

const CustomButton = `
  border-radius: 20px 4px 20px 4px;
  margin-top: 40px;
  padding: 8px 15px;

  > div div {
    font-size: 20px;
  }
`

const Parcels: React.FunctionComponent = () => {
  const sliderOfferRef = React.useRef<Slider>(null);

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC>
              <PreTitle>Estamos llevando</PreTitle>
              <Title>
                Tu encomienda
                <TitleBar />
              </Title>
              <span>GPS: Nuestras unidades son monitoreadas vía GPS las 24 horas.</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
          <TitleSection preTitle='Servicios' title='Encomiendas'/>
          <ContainerStatus>
            <ContainerForm>
              <h2>Verificar <span>estado de encomienda</span></h2>
              <p>Ingresa tu número de documento y la clave señaladas en el comprobante que se te entregó al momento de enviar tu encomienda para poder realizar seguimiento de tus envíos.</p>
              <div>
                <SelectTC textHolder='Tipo de documento'/>
                <InputWrapper>
                  <div>
                   <InputTC type='text' icon={<NumberSymbol />} textHolder='Serie documento'/>
                  </div>
                  <div>
                   <InputTC type='text' icon={<ListUl />} textHolder='Nro. Documento'/>
                  </div>
                </InputWrapper>
                <InputTC type='password' icon={<Lock />} textHolder='Clave'/>
                <ButtonTC text='Buscar encomienda' className={CustomButton} to='/busqueda-encomiendas'/>
              </div>
            </ContainerForm>
            <ContainerImageForm>
              <img src={voucher} alt='voucher' />
            </ContainerImageForm>
          </ContainerStatus>
        </SectionTC>
        <SectionTC>
          <TitleSection preTitle='Protocolo de Seguridad' title='Envío y Recepción'/>
          <AlertTC icon={<ExclamationCircle />} title="Envío y recepción de encomiendas" description='Verificar que los usuarios del servicio de envío y recepción de encomiendas cumplan con la normativa implementada por la empresa para brindar seguridad al servicio ofrecido'/>
          <ContainerParcelsService>
            {listParecelService.map(service => (
              <ParcelServiceItem
                image={service.image}
                title={service.title}
                description={service.description}
              />
            ))}
          </ContainerParcelsService>
        </SectionTC>
        <SectionTC>
          <PaymentMethods />
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default Parcels